import { Group, Vector3, GridHelper, Color, MeshBasicMaterial, LineBasicMaterial, Geometry, Line} from 'three';

class Floor extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        this.name = 'floor';

        //const color = new Color("rgb(150, 0, 255)");

        this.state = {
            hp: 10,
            collide: this.collide.bind(this),
            takeDam: this.takeDam.bind(this),
            pstate: parent.state,
            ls: [],
        };

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(51, 0, 120)"),
	          linewidth: 6,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round', //ignored by WebGLRenderer
        } );
        material.color.b = 0.0;
        material.color.r = 0.0;
        material.color.g = 0;

				//this.layers.enable( BLOOM_SCENE );

        //const gridHelper = new GridHelper(300, 50);
        var geometry = new Geometry();
        geometry.vertices.push(new Vector3(4.5,0,-4.5));
        geometry.vertices.push(new Vector3(-4.5,0,-4.5));
        geometry.vertices.push(new Vector3(-4.5,0,4.5));
        geometry.vertices.push(new Vector3(4.5,0,4.5));
        geometry.vertices.push(new Vector3(4.5,0,-4.5));

        for (var i = -15; i<=15; i++){
            for (var j = -15; j<=15; j++){
                const line = new Line(geometry, material.clone());
                if (i == -15 || i == 15 || j == -15 || j == 15){
                    line.material.color.g = 0.2;
                }
                this.add(line);
                this.state.ls.push(line);
                line.position.x += i*10;
                line.position.z += j*10;
            }
        }

        //gridHelper.material = material;
        parent.addToColliderList(this);
        parent.addToUpdateList(this);
        //this.add(gridHelper);
    }
    takeDam(){
        this.state.hp += 1;
    }
    collide(){
        const rayO = this.state.pstate.cameraP.clone();
        if (rayO.y > 1.3){
            const rayD = this.state.pstate.playerPos.clone();
            rayD.y += 10;
            rayD.sub(rayO);
            rayD.normalize();
            const norm = new Vector3(0, 1, 0);

            const a = rayD.dot(norm);
            const b = rayO.dot(norm);

            if (a > 0.01 || a < -0.01){
                const len = -b / a;
                if (len > 0.01 && len < this.state.pstate.dist){
                    const intersect = rayO.clone().add(rayD.multiplyScalar(len));
                    this.state.pstate.dist = len;
                    this.state.pstate.target = this;
                    this.state.pstate.impact = intersect;
                }
            }
        }
    }

    update(timeStamp) {
        for (var i = 0; i<this.state.ls.length; i++){
            const d = this.state.ls[i].position.distanceToSquared(this.state.pstate.playerPos);
            if (d < 4000){
                const d2 = this.state.ls[i].position.distanceToSquared(this.state.pstate.tower);
                if (d2 < 6400){
                    if (this.state.ls[i].material.color.b > 0.7*250/d){
                        this.state.ls[i].material.color.b -= .01;
                    } else if (this.state.ls[i].material.color.b < 1){
                        this.state.ls[i].material.color.b += .02;
                    }
                    if (this.state.ls[i].material.color.r > 0.2*250/d){
                        this.state.ls[i].material.color.r -= .01;
                    } else if (this.state.ls[i].material.color.r < 1) {
                        this.state.ls[i].material.color.r += .02;
                    }
                    if (this.state.ls[i].material.color.g != 0.2){
                        if (this.state.ls[i].material.color.g > 0.2*250/d2){
                            this.state.ls[i].material.color.g -= .011;
                        } else if (this.state.ls[i].material.color.g < 1) {
                            this.state.ls[i].material.color.g += .021;
                        }
                    }
                } else {
                    if (this.state.ls[i].material.color.b > 0.6*250/d){
                        this.state.ls[i].material.color.b -= .01;
                    } else if (this.state.ls[i].material.color.b < 1){
                        this.state.ls[i].material.color.b += .02;
                    }
                    if (this.state.ls[i].material.color.r > 0.2*250/d){
                        this.state.ls[i].material.color.r -= .01;
                    } else if (this.state.ls[i].material.color.r < 1) {
                        this.state.ls[i].material.color.r += .02;
                    }
                    if (this.state.ls[i].material.color.g != 0.2 && this.state.ls[i].material.color.g > 0.0){
                         this.state.ls[i].material.color.g -= 0.02;
                    }
                }


                this.state.ls[i].visible = true;
            } else {
                this.state.ls[i].visible = false;
                this.state.ls[i].material.color.r = 0;
                this.state.ls[i].material.color.b = 0;

            }
        }
    }
}

export default Floor;
